

import { LocationYears } from 'models/ActivityDataLocationYears/locationYears.model';
import { serializable, alias, list, object } from 'serializr';
import { ScopeData } from './scopes.model';
import { YearStatus } from './yearStatus.model';

export class LocationData {

    @serializable(alias('energy_and_fuel_source', list(object(ScopeData))))
    energyAndFuelSource?: ScopeData[];

    @serializable(alias('scope_completion_status', object(YearStatus)))
    scopeCompletionStatus?: YearStatus;

    @serializable(alias('years_with_scope_status', list(object(LocationYears))))
    yearsWithScopeStatus?: LocationYears[];

}